import { DetailPageSections } from "../shared";

export const EnvironmentSecurityPage = () => {
  return (
    <DetailPageSections>
      <p>Environment Security Content</p>
    </DetailPageSections>
  );
};
